import env from './env';

//const DEV_URL = 'https://api.china-news.co.jp';
//const DEV_URL = 'http://192.168.0.101:9901';
const DEV_URL = 'http://localhost:9902';
const PRO_URL = 'https://api.china-news.co.jp';

export default {
    apiUrl: (env === 'development' ? DEV_URL : PRO_URL) + '/b-api/v1/',
    dataUrl: (env === 'development' ? DEV_URL : PRO_URL) + '/',
    Url: env === 'development' ? DEV_URL : PRO_URL,
};
